export default {
  COUNTRY_CODE: 'BR',
  ID: 'pt-br',
  NUMBER_FORMAT: {
    CURRENCY_DESCRIPTION: 'Real',
    CURRENCY_SYMBOL: 'R$',
    DECIMAL_SEPARATOR: ',',
    GROUP_SEPARATOR: '.',
  },
};
